import { Chart as ChartJS } from "chart.js";

/* Same palette as the landing page (landing/css/styles.css). */
export const C = {
  cream: "#FBF6EA",
  creamDeep: "#F3EAD5",
  ink: "#2A2A1C",
  inkSoft: "#57543F",
  inkFaint: "#83805F",
  olive900: "#2C3320",
  olive600: "#647A3F",
  olive300: "#A7BE78",
  yellow500: "#EEC13B",
  coral700: "#B14B2C",
  coral600: "#CE5B34",
  coral500: "#E2703F",
};

const FONT = "'DM Sans', system-ui, -apple-system, sans-serif";

let applied = false;
export function applyChartDefaults() {
  if (applied) return;
  applied = true;
  ChartJS.defaults.font.family = FONT;
  ChartJS.defaults.font.size = 12;
  ChartJS.defaults.color = C.inkFaint;
}

const RATING_COLORS = {
  "muy malo": C.coral700,
  malo: C.coral500,
  regular: C.yellow500,
  bueno: C.olive300,
  "muy bueno": C.olive600,
};
const FALLBACK = [C.olive600, C.yellow500, C.coral500, C.olive300, C.coral700];

export function ratingColor(label, i = 0) {
  return (
    RATING_COLORS[String(label).trim().toLowerCase()] ||
    FALLBACK[i % FALLBACK.length]
  );
}

const tooltip = {
  backgroundColor: C.olive900,
  titleColor: C.cream,
  bodyColor: C.cream,
  cornerRadius: 10,
  padding: 10,
  displayColors: false,
};

const legend = {
  position: "bottom",
  labels: {
    usePointStyle: true,
    pointStyle: "circle",
    boxWidth: 8,
    boxHeight: 8,
    color: C.inkSoft,
    padding: 14,
  },
};

const axes = {
  x: {
    grid: { display: false },
    border: { display: false },
    ticks: { maxTicksLimit: 8 },
  },
  y: {
    beginAtZero: true,
    grid: { color: C.creamDeep },
    border: { display: false },
    ticks: { maxTicksLimit: 5 },
  },
};

export function lineDataset(ds) {
  const single = !ds.data || ds.data.length <= 1;
  return {
    ...ds,
    fill: true,
    tension: 0.4,
    borderColor: C.coral600,
    borderWidth: 3,
    borderCapStyle: "round",
    borderJoinStyle: "round",
    backgroundColor: (ctx) => {
      const area = ctx.chart.chartArea;
      if (!area) return "rgba(206, 91, 52, 0.12)";
      const g = ctx.chart.ctx.createLinearGradient(0, area.top, 0, area.bottom);
      g.addColorStop(0, "rgba(206, 91, 52, 0.22)");
      g.addColorStop(1, "rgba(206, 91, 52, 0)");
      return g;
    },
    pointRadius: single ? 4 : 0,
    pointHoverRadius: 5,
    pointHitRadius: 14,
    pointBackgroundColor: C.cream,
    pointBorderColor: C.coral600,
    pointBorderWidth: 2,
  };
}

export const lineOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: "index", intersect: false },
  plugins: { legend: { display: false }, tooltip },
  scales: axes,
};

export function barDataset(ds, i) {
  const color = ratingColor(ds.label, i);
  return {
    ...ds,
    backgroundColor: color,
    borderWidth: 0,
    borderRadius: 6,
    borderSkipped: false,
    maxBarThickness: 36,
  };
}

export const barOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend, tooltip },
  scales: axes,
};

export function polarData(data) {
  const labels = data.labels || [];
  return {
    ...data,
    datasets: (data.datasets || []).map((ds) => ({
      ...ds,
      backgroundColor: labels.map((l, i) => ratingColor(l, i) + "CC"),
      borderColor: C.cream,
      borderWidth: 2,
    })),
  };
}

export const polarOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend, tooltip },
  scales: {
    r: {
      grid: { color: C.creamDeep },
      ticks: { backdropColor: "transparent", maxTicksLimit: 4 },
    },
  },
};
